import { clearTypeOfCategory, selectCategoryName, selectCategoryTypeId, setTypeOfCategory } from '../../../../features/modal/modalSlice';
import { useDispatch, useSelector } from 'react-redux';
import { IcTwotoneArrowBack } from '../../../../assets/icons/Icons';
import Loading from '../../../ui/Loading';
import ErrorMessage from '../../../ui/ErrorMessage';
import { selectCurrentPackageItems } from '../../../../features/package/packageSlice';
import { useNewPackageManager } from '../../../../hooks/packages/useNewPackageManager';
import { useMasterData } from '../../../../hooks/api/useMasterData';
import { useMemo, useState } from 'react';
import SortedProductBaseOnCategoryItem from '../../../common/items/SortedProductBaseOnCategoryItem';
import { useQueryData } from '../../../../hooks/api/useQueryData';
import { CategoryData } from '../../../../features/setup/setupResponse';
import SetupTHead from '../../../common/theads/SetupTHead';
import { updatePackageTHeadData } from '../../../../data/admin-data';
import UpdatePackageItemAvailableTBody from '../../../common/tbody/UpdatePackageItemAvailableTBody';

export default function NewPackageProduct() {

    const dispatch = useDispatch()
    const currentPackageItems = useSelector(selectCurrentPackageItems);
    const categoryId = useSelector(selectCategoryTypeId);
    const categoryName = useSelector(selectCategoryName);
    const { getCategory, isErrorGetCategory, isLoadingGetCategory, errorMessageGetCategory } = useMasterData()
    const {  productBaseOnCategory, isErrorProductBaseOnCategory, isLoadingProductBaseOnCategory, errorMessageProductBaseOnCategory, } = useQueryData()
    const { handleAddProductToPackage, } = useNewPackageManager();
    const [isShowProductItems, setIsShowProductItems] = useState<number>(0)

    const activeCategories = useMemo(() => {
        return getCategory?.filter(category => category.isActive) ?? [];
    }, [getCategory]);
    
    const sortedProductBaseOnCategory = useMemo(() => {
        return productBaseOnCategory
            ?.filter(product => product.isAvailable)
            ?.slice()
            ?.sort((a, b) => {
                const catA = a.categoryInfo?.categoryName?.toLowerCase() || '';
                const catB = b.categoryInfo?.categoryName?.toLowerCase() || '';
                const catCompare = catA.localeCompare(catB);
                if (catCompare !== 0) return catCompare; // sort by category first
                // same category → sort by size (string)
                const sizeA = a.sizeInfo?.size?.toLowerCase() || '';
                const sizeB = b.sizeInfo?.size?.toLowerCase() || '';
                // Place 'None' or empty sizes last
                if (sizeA === 'none' || sizeA === '') return 1;
                if (sizeB === 'none' || sizeB === '') return -1;
                
                if (sizeA.length !== sizeB.length) {
                    return sizeA.length - sizeB.length;
                }
                return sizeA.localeCompare(sizeB);
        }) ?? []
    }, [ productBaseOnCategory ])

    const handleClearCategory = () => {
        dispatch(clearTypeOfCategory());
        dispatch(clearTypeOfCategory());
    }

    const handleClickCategory = (category: CategoryData, categoryId: number) => {
        setIsShowProductItems(categoryId)
        dispatch(setTypeOfCategory(category));
    }
    // console.log("sortedProductBaseOnCategory: ", sortedProductBaseOnCategory)
    // console.log("productBaseOnCategory: ", productBaseOnCategory)
    // console.log("activeCategories: ", activeCategories)
    
    return (
        <>
            {!isLoadingProductBaseOnCategory  && isShowProductItems === categoryId && (
                <div className={`flex justify-between px-2`}>
                    <div className='' >
                        <button onClick={handleClearCategory}>
                            <IcTwotoneArrowBack height={20} width={20} color='red'/>
                        </button>
                    </div>
                    <p className='text-sm font-medium'>{categoryName}</p>
                </div>
            )}
            {isShowProductItems === categoryId ? (
                <div className='h-full overflow-hidden bg-white rounded border'>
                    <div className='overflow-y-auto h-full'>
                        <table className='min-w-max w-full'>
                            <SetupTHead data={updatePackageTHeadData}/>
                            <UpdatePackageItemAvailableTBody
                                currentPackage={currentPackageItems}
                                data={sortedProductBaseOnCategory}
                                isLoading={isLoadingProductBaseOnCategory}
                                isError={isErrorProductBaseOnCategory}
                                isEmpty={getCategory.length === 0}
                                errorMessage={errorMessageProductBaseOnCategory}
                                handleAddProductToPackage={handleAddProductToPackage}
                            />
                        </table>
                    </div>
                </div>
            ) : (
                <>
                    { isLoadingGetCategory ? (
                        <div className='w-full flex justify-center'>
                            <Loading message="Loading category..." />
                        </div>
                    ) : isErrorGetCategory ? (
                        <div className='h-full w-full flex items-center justify-center'>
                            <ErrorMessage message={errorMessageGetCategory} />
                        </div>
                    ) : activeCategories.length === 0 ? (
                        <div className='w-full flex justify-center'>
                            No category found.
                        </div>
                    ) : (
                        <div className='grid grid-cols-2 gap-3 p-3'>
                            {activeCategories.map((cat) => {
                                return (
                                    <div 
                                        key={cat.categoryID}
                                        onClick={() => handleClickCategory(cat, cat.categoryID)}
                                        className='cursor-pointer bg-cbColorSecond rounded flex items-center justify-center'
                                    >
                                        <div className='flex justify-center p-2 text-[15px] items-center text-center text-cbColorDark font-medium'>
                                            {cat.categoryName}
                                        </div>
                                    </div>
                                )
                            })}
                        </div>
                    )}
                </>
            )}
        </>
    )
}
